/**
 * Actors - Archive (listing view)
 */

'use strict';

var helper = require('../misc/helpers');
var layout = require('../misc/layout');
var searchUtil = require('../misc/search');

// Constructor
var FrontActorsArchive = function () {
    if (!$('body').hasClass('post-type-archive-cm-actors')) {
        return;
    }

    $(document).ready((function () {
        if (bowser.mobile) {
            this.$searchForm = $('#actors-search-mobile');
        } else {
            this.$searchForm = $('#actors-search');
        }

        if ($(window).width() > 500) {
            this.uiInitSearchForm();
            this.uiInitAgeRange();
            this.uiSlideDownAdvancedSearch();
        } else {
            this.uiInitSearchFormMobile();
        }

        this.reinitializeSearch();
        this.thumbActorOnHover();
        this.alphaActorOnHover();
        this.filteringActors();
        this.searchForm();
        this.launchSearchFromHomepage();
        this.populateSearchFormFromCookies();
        this.searchByGetParameter();

        //if ($('.alpha-listing').hasClass('hidden') || $('.alpha-listing').parent().hasClass('hidden')) {
            this.infiniteScroll();
        //}
    }).bind(this));
};

FrontActorsArchive.prototype = {
    lockAjaxGetResults: false,
    tempAjaxGetResultsPostData: {},
    searchFormCookieName: 'actor_searchform',
    searchFormForceCreateCookie: false,
    $searchForm: null,

    infiniteScroll: function () {
        var self = this;

        var nbTotalActors = $('#actors-results ul').attr('data-numberTotal');
        var initialItemHeight = $('#actors-results ul li.item:last').height();
        var initialItemsNb = $('#actors-results ul li.item').length;

        var setInfinite = function () {
            // Bug fix: initialItemHeight and initialItemsNb could be unknown when the search form is triggered from cookies
            if (initialItemHeight == undefined) {
                initialItemHeight = $('#actors-results ul li.item:last').height();
            }
            if (initialItemsNb == 0) {
                initialItemsNb = $('#actors-results ul li.item').length;
            }

            if ($('#actors-results ul li.item:last').length > 0) {
                var lastItemOffset = $('#actors-results ul li.item:last').offset();

                // If the user reach the bottom of the events list
                if (lastItemOffset !== undefined && ((lastItemOffset.top + initialItemHeight) - $(window).height() <= $(window).scrollTop()) && initialItemsNb >= 16 && initialItemsNb < nbTotalActors) {
                    if (self.lockAjaxGetResults) {
                        // Pending AJAX request... wait
                        return;
                    }

                    self.lockAjaxGetResults = true;

                    // Display the loading spinner
                    $('#actors-results .loading').fadeIn();

                    var nbDisplayedItems = $('#actors-results ul li.item').length;
                    var startTime = new Date().getTime();

                    self.ajaxGetResults(function (response) {
                        if (response.success) {
                            var fakeLoadingTime = 0;
                            var requestTime = new Date().getTime() - startTime;

                            if (requestTime < 1000) {
                                fakeLoadingTime = 1000 - requestTime;
                            }

                            var appendNewItems = function(response) {
                                var total = parseInt(response.data.nbTotalActors);

                                // Append the events to the existing list
                                $('#actors-results ul').append(response.data.actors);

                                // Update the display
                                self.updateDisplay();

                                if (bowser.firefox) {
                                    // Bux fix for Firefox
                                    $(window).trigger('resize');
                                }
                            };

                            if (fakeLoadingTime > 0) {
                                setTimeout(appendNewItems(response), fakeLoadingTime);
                            } else {
                                appendNewItems(response);
                            }
                        } else {
                           M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                        }

                        $('.btn-reinit').removeAttr('data-activated');

                        self.lockAjaxGetResults = false;
                    }, function (jqXHR, textStatus) {
                        $('.btn-reinit').removeAttr('data-activated');

                        self.lockAjaxGetResults = false;
                        console.log("Request failed: " + textStatus);
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }, nbDisplayedItems);
                }
            }
        };

        $(window).on('scroll touchmove', setInfinite);
        $(window).on('resize', setInfinite);

        setInfinite();
    },

    ajaxGetResults: function (callbackDone, callbackFail, offset) {
        var searchValues = this.prepareData();

        var btnReinit = false;
        $('.btn-reinit').each(function() {
            if ($(this).attr('data-activated')) {
                btnReinit = true;
            }
        });

        //  NB: With this variable, we'll be able to access sent data in the "done()" callback function
        this.tempAjaxGetResultsPostData = {
            action: 'actors.get_results',
            security: comedien.security,
            isAlpha: searchValues['isAlphaValue'],
            nbDisplayedActors: offset,
            video: searchValues['videoValue'],
            audio: searchValues['audioValue'],
            news: searchValues['newsValue'],
            nameActor: DOMPurify.sanitize($('#nameActor', this.$searchForm).val()),
            sexe: searchValues['sexeValue'],
            minAge: searchValues['minAgeValue'],
            maxAge: searchValues['maxAgeValue'],
            skins: $('#advanced-actors-search #skins').val(),
            bodySizes: $('#advanced-actors-search #bodySizes').val(),
            corpulences: $('#advanced-actors-search #corpulences').val(),
            hairColors: $('#advanced-actors-search #hairColors').val(),
            eyeColors: $('#advanced-actors-search #eyeColors').val(),
            skills: searchValues['skillValues'],
            driverLicences: $('#advanced-actors-search #driverLicences').val(),
            languages: $('#advanced-actors-search #languages').val(),
            countries: $('#advanced-actors-search #countries').val(),
            cantons: $('#advanced-actors-search #cantons').val(),
            status: $('#advanced-actors-search #status').val(),
            tribute: searchValues['tributeValue'],
            silhouette: searchValues['silhouetteValue'],
            nationalities: $('#advanced-actors-search #nationalities').val(),
            btnReinit: (btnReinit === true) ? 1 : 0,
        };

        if (bowser.mobile) {
            searchValues['hasSearchCriteria'] = true;

            this.tempAjaxGetResultsPostData = {
                action: 'actors.get_results',
                security: comedien.security,
                isAlpha: searchValues['isAlphaValue'],
                nbDisplayedActors: offset,
                video: searchValues['videoValue'],
                audio: searchValues['audioValue'],
                news: searchValues['newsValue'],
                nameActor: DOMPurify.sanitize($('#actors-search-mobile #nameActor').val()),
                sexe: searchValues['sexeValue'],
                minAge: searchValues['minAgeValue'],
                maxAge: searchValues['maxAgeValue'],
                skins: $('#actors-search-mobile #skins').val(),
                bodySizes: $('#actors-search-mobile #bodySizes').val(),
                corpulences: $('#actors-search-mobile #corpulences').val(),
                hairColors: $('#actors-search-mobile #hairColors').val(),
                eyeColors: $('#actors-search-mobile #eyeColors').val(),
                skills: searchValues['skillValues'],
                driverLicences: $('#actors-search-mobile #driverLicences').val(),
                languages: $('#actors-search-mobile #languages').val(),
                countries: $('#actors-search-mobile #countries').val(),
                cantons: $('#actors-search-mobile #cantons').val(),
                status: $('#actors-search-mobile #status').val(),
                tribute: searchValues['tributeValue'],
                silhouette: searchValues['silhouetteValue'],
                nationalities: $('#actors-search-mobile #nationalities').val(),
            };
        }

        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: this.tempAjaxGetResultsPostData
        }).done(callbackDone).fail(callbackFail);
    },

    prepareData: function () {
        var hasSearchCriteria = false;

        var searchValues = [];

        if ($('#alpha-display').hasClass('active')) {
            searchValues['isAlphaValue'] = 1;
        } else {
            searchValues['isAlphaValue'] = 0;
        }

        if ($('#video-filter').hasClass('active')) {
            searchValues['videoValue'] = 1;
            hasSearchCriteria = true;
        } else {
            searchValues['videoValue'] = 0;
        }

        if ($('#audio-filter').hasClass('active')) {
            searchValues['audioValue'] = 1;
            hasSearchCriteria = true;
        } else {
            searchValues['audioValue'] = 0;
        }

        if ($('#news-filter').hasClass('active')) {
            searchValues['newsValue'] = 1;
            hasSearchCriteria = true;
        } else {
            searchValues['newsValue'] = 0;
        }

        if ($('#age', this.$searchForm).attr('data-0') !== null || $('#age', this.$searchForm).attr('data-0') !== undefined) {
            searchValues['minAgeValue'] = $('#age', this.$searchForm).attr('data-0');
            if (parseInt(searchValues['minAgeValue']) > 18) {
                hasSearchCriteria = true;
            }
        } else {
            searchValues['minAgeValue'] = 0;
        }

        if ($('#age', this.$searchForm).attr('data-1') !== null || $('#age', this.$searchForm).attr('data-1') !== undefined) {
            searchValues['maxAgeValue'] = $('#age', this.$searchForm).attr('data-1');
            if (parseInt(searchValues['maxAgeValue']) < 100) {
                hasSearchCriteria = true;
            }
        } else {
            searchValues['maxAgeValue'] = 0;
        }

        if (bowser.mobile && $('.search-form-mobile').length > 0) {
            if ($('input#minAge').length > 0 && $('input#minAge').val() != '') {
                searchValues['minAgeValue'] = parseInt($('input#minAge').val());
                hasSearchCriteria = true;
            }
            if ($('input#maxAge').length > 0 && $('input#maxAge').val() != '') {
                searchValues['maxAgeValue'] = parseInt($('input#maxAge').val());
                hasSearchCriteria = true;
            }
        }

        // Gender
        if (bowser.mobile && $('.search-form-mobile').length > 0) {
            searchValues['sexeValue'] = $('#actors-search-mobile #sexe').val();
        } else {
            searchValues['sexeValue'] = $('#sexe', this.$searchForm).val();
        }
        if ($('#sexe').val().length > 0) {
            hasSearchCriteria = true;
        }

        // Skills
        if (bowser.mobile && $('.search-form-mobile').length > 0) {
            var checkedSkills = $('#actors-search-mobile input.skills:checkbox:checked').map(function () {
                return this.value;
            }).get().join(',');
        } else {
            var checkedSkills = $('#advanced-actors-search input.skills:checkbox:checked').map(function () {
                return this.value;
            }).get().join(',');
        }

        searchValues['skillValues'] = checkedSkills.split(',');

        if (searchValues['skillValues'][0].length > 0) {
            hasSearchCriteria = true;
        }

        // Tribute
        if (bowser.mobile) {
            if ($('#tribute_mobile').is(':checked')) {
                searchValues['tributeValue'] = 1;
            } else {
                searchValues['tributeValue'] = 0;
            }
        } else {
            if ($('#advanced-actors-search #tribute').is(':checked')) {
                searchValues['tributeValue'] = 1;
            } else {
                searchValues['tributeValue'] = 0;
            }
        }

        // Silouhette
        if (bowser.mobile) {
            if ($('#silhouette_mobile').is(':checked')) {
                searchValues['silhouetteValue'] = 1;
            } else {
                searchValues['silhouetteValue'] = 0;
            }
        } else {
            if ($('#advanced-actors-search #silhouette').is(':checked')) {
                searchValues['silhouetteValue'] = 1;
            } else {
                searchValues['silhouetteValue'] = 0;
            }
        }

        // ---

        if (($('#nameActor', this.$searchForm).length > 0 && $('#nameActor', this.$searchForm).val().length > 0) ||
            ($('#advanced-actors-search #skins').length > 0 && ($('#advanced-actors-search #skins').val() || '').length > 0) ||
            ($('#advanced-actors-search #bodySizes').length > 0 && ($('#advanced-actors-search #bodySizes').val() || '').length > 0) ||
            ($('#advanced-actors-search #corpulences').length > 0 && ($('#advanced-actors-search #corpulences').val() || '').length > 0) ||
            ($('#advanced-actors-search #hairColors').length > 0 && ($('#advanced-actors-search #hairColors').val() || '').length > 0) ||
            ($('#advanced-actors-search #eyeColors').length > 0 && ($('#advanced-actors-search #eyeColors').val() || '').length > 0) ||
            ($('#advanced-actors-search #driverLicences').length > 0 && ($('#advanced-actors-search #driverLicences').val() || '').length > 0) ||
            ($('#advanced-actors-search #languages').length > 0 && ($('#advanced-actors-search #languages').val() || '').length > 0) ||
            ($('#advanced-actors-search #nationalities').length > 0 && ($('#advanced-actors-search #nationalities').val() || '').length > 0) ||
            (searchValues.hasOwnProperty('tributeValue') && searchValues['tributeValue'] === 1) ||
            (searchValues.hasOwnProperty('silhouetteValue') && searchValues['silhouetteValue'] === 1) ||
            ($('#advanced-actors-search #countries').length > 0 && ($('#advanced-actors-search #countries').val() || '').length > 0) ||
            ($('#advanced-actors-search #cantons').length > 0 && ($('#advanced-actors-search #cantons').val() || '').length > 0)) {
            hasSearchCriteria = true;
        }

        searchValues['hasSearchCriteria'] = hasSearchCriteria;

        return searchValues;
    },

    thumbActorOnHover: function () {
        $('body').on('mouseenter', 'ul.actors-listing li', function () {
            $(this).find('.info').removeClass('hidden');
            $(this).find('.info .inner').addClass('z-depth-3');
        });

        $('body').on('mouseleave', 'ul.actors-listing li', function () {
            $(this).find('.info').addClass('hidden');
            $(this).find('.info .inner').removeClass('z-depth-3');
        });
    },

    alphaActorOnHover: function () {
        $('body').on('mouseenter', 'ul.alpha-listing li', function () {
            $('.alpha-listing li').not(this).addClass('lighter');
        });

        $('body').on('mouseout', 'ul.alpha-listing li', function () {
            $('.alpha-listing li').removeClass('lighter');
        });
    },

    filteringActors: function () {
        var self = this;

        $('.right-text button').on('click', function () {

            if (!$(this).hasClass('active')) {
                $(this).parent().find('button').removeClass('active');
                $(this).addClass('active');
            } else {
                $(this).parent().find('button').removeClass('active');
            }

            var searchValues = self.prepareData();

            if (!searchValues['hasSearchCriteria']) {
                // Go to /actors/?alphabetic because of lack of criteria
                if (searchValues['isAlphaValue']) { 
                    var url = $('#alpha-display').data('url');
                } else {
                    var url = $('#thumb-display').data('url');
                }
                window.location.href = url;
                return;
            }

            var offset = 0;

            if (self.lockAjaxGetResults) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxGetResults = true;

            // Display the loading spinner
            $('ul.actors-listing').html('');
            $('#actors .loading').fadeIn();

            self.ajaxGetResults(function (response) {
                if (response.success) {
                    setTimeout(function () {
                        var total = parseInt(response.data.nbTotalActors);

                        var entity = $('#actors h1').data("entity");

                        // Update the new actors in list
                        if ($('#alpha-display').hasClass('active')) {
                       
                            $('ul.alpha-listing').html(response.data.actors);
                     
                        } else {
                            $('ul.actors-listing').html(response.data.actors);
                        }

                        if (total == 0) {
                            $('#actors h1').html('<span>' + comedien.i18n.placesTitleCountZero + '</span>' + ' ' + entity);
                            $('ul.actors-listing').html();
                            $('ul.alpha-listing').html();
                        } else if (total == 1) {
                            $('#actors h1').html('<span>' + total + '</span>' + ' ' + entity);
                        } else {
                            $('#actors h1').html('<span>' + total + '</span>' + ' ' + entity + 's');
                        }

                        // Display the item count
                        $('.title-items-count').css('opacity', 1);

                        // Update the display
                        self.updateDisplay();

                        $('#actors .results').mCustomScrollbar("update");
                        $('ul.actors-listing').attr("data-numberTotal", total);

                    }, 1000);
                } else {
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }

                $('.btn-reinit').removeAttr('data-activated');

                self.lockAjaxGetResults = false;
            }, function (jqXHR, textStatus) {
                $('.btn-reinit').removeAttr('data-activated');

                self.lockAjaxGetResults = false;
                console.log("Request failed: " + textStatus);
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            }, offset);
        });
    },

    updateDisplay: function () {
        // Hide the loading spinner
        $('#actors .loading').fadeOut();

        // Hide the alphabets if alpha display
        if ($('#alpha-display').hasClass('active')) {
            $('.alphabet').addClass('hidden');
        }

        // Hide the "new search" button if displayed
        $('.center-align .back').addClass('hidden');

        // Show the right type of display
        if ($('#alpha-display').hasClass('active')) {
            $('.results').addClass('hidden');
            $('.results-noscroll').removeClass('hidden');
        } else {
            $('.results-noscroll').addClass('hidden');
            $('.results').removeClass('hidden');
        }
    },

    uiInitAgeRange: function () {
        if ($('#age', this.$searchForm).length == 0) {
            return;
        }

        var ageRange = $('#age')[0];

        if (ageRange.noUiSlider !== undefined) {
            // noUiSlider already initialized
            return;
        }

        var ageMin = 18;
        if ($('#age').attr('data-0') != undefined) {
            ageMin = $('#age').attr('data-0');
        }

        var ageMax = 100;
        if ($('#age').attr('data-1') != undefined) {
            ageMax = $('#age').attr('data-1');
        }

        noUiSlider.create(ageRange, {
            start: [ageMin, ageMax],
            connect: true,
            step: 1,
            range: {
                'min': 18,
                'max': 100
            },
            format: wNumb({
                decimals: 0
            })
        });

        // Update values 
        ageRange.noUiSlider.on('update', function (values, handle) {
            $('#age').attr('data-' + handle, values[handle])
        });
    },

    uiInitSearchForm: function () {
        $('#advanced-actors-search select').formSelect();

        $('.filters button').on('click', function() {
            if (!$(this).hasClass('active')) {
                $(this).parent().find('button').removeClass('active');
                $(this).addClass('active');
            } else {
                $(this).parent().find('button').removeClass('active');
            }
        });

        $('.select-search select').formSelect();

        layout.disableMaterializeDropdownOnMobile($('#advanced-actors-search'));
    },

    uiSlideDownAdvancedSearch: function () {
        $('#search-box #more-criteria').on('click', function () {
            var button = $(this);

            $('.advanced-search').toggle(0, function () {
                $('#actors .overlay').toggleClass('hidden');

                // Updating title's button
                var newTitle = button.data("title");
                var currentTitle = button.text();
                button.text(newTitle);
                button.data("title", currentTitle);

                // Updating actors'listing 
                $('#actors').toggleClass('without-advanced-search');
            });
        });
    },

    uiInitSearchFormMobile: function() {
        var self = this;

        $('#search-box-mobile-btn a').on('click', function(e) {
            e.preventDefault();

            // Set a timeout to wait after misc/search.js
            setTimeout(function() {
                self.uiInitAgeRange();
            }, 1000);
        });

        if (window.location.hash) {
            var hash = window.location.hash.substring(1);
            if (hash == 'searchForm') {
                setTimeout(function() {
                    $('#search-box-mobile-btn a').trigger('click');
                }, 1000);
            }
        }
    },

    searchForm: function () {
        var self = this;

        if (!bowser.mobile) {
            // Search on desktop device

            $('#video-filter').on('click', function() {
                this.$searchForm.add('#advanced-actors-search').trigger('submit');
            });
            $('#audio-filter').on('click', function() {
                this.$searchForm.add('#advanced-actors-search').trigger('submit');
            });
            $('#news-filter').on('click', function() {
                this.$searchForm.add('#advanced-actors-search').trigger('submit');
            });

            this.$searchForm.add('#advanced-actors-search').on('submit', function (e) {
                e.preventDefault();

                // Hide the "new search" button if displayed
                $('.center-align .back').addClass('hidden');

                // Slide up the search panel
                if ($('.advanced-search').is(':visible')) {
                    $('#search-box #more-criteria').trigger('click');
                }

                if (self.lockAjaxGetResults) {
                    // Pending AJAX request... do nothing
                    return;
                }

                self.lockAjaxGetResults = true;

                // Display the loading spinner
                $('ul.actors-listing').html('');
                $('ul.alpha-listing').html('');
                $('section#actors .loading').fadeIn();
                $('section#actors .results').mCustomScrollbar('update');
                $('section#actors .results').mCustomScrollbar('scrollTo', 'top');

                self.ajaxGetResults(function (response) {
                    if (response.success) {
                        setTimeout(function () {
                            var total = parseInt(response.data.nbTotalActors);

                            var entity = $('#actors h1').data("entity");

                            if (total == 0) {
                                $('#actors h1').html('<span>' + comedien.i18n.placesTitleCountZero + '</span>' + ' ' + entity);
                                $('ul.actors-listing').html()
                            } else if (total == 1) {
                                $('#actors h1').html('<span>' + total + '</span>' + ' ' + entity);
                            } else {
                                $('#actors h1').html('<span>' + total + '</span>' + ' ' + entity + 's');
                            }

                            // Display the item count
                            $('.title-items-count').css('opacity', 1);

                            // Update the display
                            self.updateDisplay();

                            if (total > 0) {
                                // Update the new actors in list
                                if ($('#alpha-display').hasClass('active')) {
                                    $('ul.alpha-listing').html(response.data.actors);
                                } else {
                                    $('ul.actors-listing').html(response.data.actors);
                                }
                            } else {
                                $('.center-align .back').removeClass('hidden');
                            }

                            $('#actors .results').mCustomScrollbar("update");
                            $('ul.actors-listing').attr("data-numberTotal", total);
                        }, 1000);

                        // Remember the search criteria for 1 day through cookies

                        var dataCookieObj = {};

                        $.each(self.tempAjaxGetResultsPostData, function(index, value) {
                            if (index != 'action' && index != 'security' && index != 'nbDisplayedActors' && index != 'isAlpha') {
                                if (typeof(value) != "undefined" && value != null) {
                                    dataCookieObj[index] = value;
                                }
                            }
                        });

                        if (self.searchFormForceCreateCookie) {
                            helper.setCookie(self.searchFormCookieName, JSON.stringify(dataCookieObj), 1);
                            self.searchFormForceCreateCookie = false;
                        } else if (typeof e.isTrigger === 'undefined' || !e.isTrigger) {
                            helper.setCookie(self.searchFormCookieName, JSON.stringify(dataCookieObj), 1);
                        }
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }

                    $('.btn-reinit').removeAttr('data-activated');

                    self.lockAjaxGetResults = false;
                }, function (jqXHR, textStatus) {
                    $('.btn-reinit').removeAttr('data-activated');

                    self.lockAjaxGetResults = false;
                    console.log("Request failed: " + textStatus);
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }, 0);
            });
        } else {
            // Search on mobile device

            $('#video-filter').on('click', function() {
                $(this).toggleClass('active');
                self.$searchForm.trigger('submit');
            });
            $('#audio-filter').on('click', function() {
                $(this).toggleClass('active');
                self.$searchForm.trigger('submit');
            });
            $('#news-filter').on('click', function() {
                $(this).toggleClass('active');
                self.$searchForm.trigger('submit');
            });

            this.searchFormForceCreateCookie = true;

            $('body').on('submit', self.$searchForm, function(e) {
                e.preventDefault();

                if (self.lockAjaxGetResults) {
                    // Pending AJAX request... do nothing
                    return;
                }

                self.lockAjaxGetResults = true;

                $('#search-box-mobile .btn-submit').addClass('disabled');
                $('#search-box-mobile .close-search').trigger('click');

                // Display the loading spinner
                $('ul.actors-listing').html('');
                $('ul.alpha-listing').html('');
                $('section#actors .loading').fadeIn();
                $('section#actors .results').mCustomScrollbar('update');
                $('section#actors .results').mCustomScrollbar('scrollTo', 'top');

                self.ajaxGetResults(function (response) {
                    if (response.success) {
                        setTimeout(function () {
                            $('#search-box-mobile .btn-submit').removeClass('disabled');

                            var total = parseInt(response.data.nbTotalActors);

                            var entity = $('#actors h1').data("entity");

                            if (total == 0) {
                                $('#actors h1').html('<span>' + comedien.i18n.placesTitleCountZero + '</span>' + ' ' + entity);
                                $('ul.actors-listing').html()
                            } else if (total == 1) {
                                $('#actors h1').html('<span>' + total + '</span>' + ' ' + entity);
                            } else {
                                $('#actors h1').html('<span>' + total + '</span>' + ' ' + entity + 's');
                            }

                            // Display the item count
                            $('.title-items-count').css('opacity', 1);

                            // Update the display
                            self.updateDisplay();

                            if (total > 0) {
                                // Update the new actors in list
                                if ($('#alpha-display').hasClass('active')) {
                                    $('ul.alpha-listing').html(response.data.actors);
                                } else {
                                    $('ul.actors-listing').html(response.data.actors);
                                }
                            } else {
                                $('.center-align .back').removeClass('hidden');
                            }

                            $('#actors .results').mCustomScrollbar("update");
                            $('ul.actors-listing').attr("data-numberTotal", total);
                        }, 1000);

                        // Remember the search criteria for 1 day through cookies

                        var dataCookieObj = {};

                        $.each(self.tempAjaxGetResultsPostData, function(index, value) {
                            if (index != 'action' && index != 'security' && index != 'nbDisplayedActors' && index != 'isAlpha') {
                                if (typeof(value) != "undefined" && value != null) {
                                    dataCookieObj[index] = value;
                                }
                            }
                        });

                        if (self.searchFormForceCreateCookie) {
                            helper.setCookie(self.searchFormCookieName, JSON.stringify(dataCookieObj), 1);
                            self.searchFormForceCreateCookie = false;
                        } else if (typeof e.isTrigger === 'undefined' || !e.isTrigger) {
                            helper.setCookie(self.searchFormCookieName, JSON.stringify(dataCookieObj), 1);
                        }
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }

                    $('.btn-reinit').removeAttr('data-activated');

                    self.lockAjaxGetResults = false;
                }, function (jqXHR, textStatus) {
                    $('.btn-reinit').removeAttr('data-activated');

                    self.lockAjaxGetResults = false;
                    console.log("Request failed: " + textStatus);
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);

                    $('#search-box-mobile .btn-submit').removeClass('disabled');
                    $('#search-box-mobile .close-search').trigger('click');
                }, 0);
            });
        }
    },

    populateSearchFormFromCookies: function() {
        var self = this;

        var dataCookieStr = helper.getCookie(this.searchFormCookieName);
        if (dataCookieStr == '') {
            return;
        }

        var dataCookieObj = JSON.parse(dataCookieStr);
        if (dataCookieObj === 'undefined' || Object.keys(dataCookieObj).length == 0) {
            return;
        }

        var minAge = 18;
        var maxAge = 100;

        searchUtil.uiMobileSearched();

        if ($(window).width() < 500) {
            // Bug fix (i don"t understand why but we need to simulate a click on the mobile search btn to see changes on input/dropdown)...
            $('#search-box-mobile-btn a').trigger('click');
        }

        $.each(dataCookieObj, function(index, value) {
            switch(index) {
                case 'video':
                    if (value == 1) {
                        $('#video-filter').addClass('active');
                    }
                    break;
                case 'audio':
                    if (value == 1) {
                        $('#audio-filter').addClass('active');
                    }
                    break;
                case 'nameActor':
                    if (value != '') {
                        var clean = DOMPurify.sanitize(value.trim());
                        $('#nameActor', self.$searchForm).val(clean);
                    }
                    break;
                case 'sexe':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            $('#sexe', self.$searchForm).val(value);
                            $('#sexe', self.$searchForm).formSelect('destroy');
                            $('#sexe', self.$searchForm).formSelect();
                        }
                    }
                    break;
                case 'minAge':
                    var age = parseInt(value, 10);
                    if (age >= 0) {
                        minAge = value;
                    }
                    break;
                case 'maxAge':
                    var age = parseInt(value, 10);
                    if (age >= 0) {
                        maxAge = value;
                    }
                    break;
                case 'skins':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            if ($(window).width() > 500) {
                                $('#advanced-actors-search #skins').val(value);
                                $('#advanced-actors-search #skins').formSelect('destroy');
                                $('#advanced-actors-search #skins').formSelect();
                            } else {
                                $('#skins', self.$searchForm).val(value);
                                $('#skins', self.$searchForm).formSelect('destroy');
                                $('#skins', self.$searchForm).formSelect();
                            }
                        }
                    }
                    break;
                case 'bodySizes':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            if ($(window).width() > 500) {
                                $('#advanced-actors-search #bodySizes').val(value);
                                $('#advanced-actors-search #bodySizes').formSelect('destroy');
                                $('#advanced-actors-search #bodySizes').formSelect();
                            } else {
                                $('#bodySizes', self.$searchForm).val(value);
                                $('#bodySizes', self.$searchForm).formSelect('destroy');
                                $('#bodySizes', self.$searchForm).formSelect();
                            }
                        }
                    }
                    break;
                case 'corpulences':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            if ($(window).width() > 500) {
                                $('#advanced-actors-search #corpulences').val(value);
                                $('#advanced-actors-search #corpulences').formSelect('destroy');
                                $('#advanced-actors-search #corpulences').formSelect();
                            } else {
                                $('#corpulences', self.$searchForm).val(value);
                                $('#corpulences', self.$searchForm).formSelect('destroy');
                                $('#corpulences', self.$searchForm).formSelect();
                            }
                        }
                    }
                    break;
                case 'hairColors':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            if ($(window).width() > 500) {
                                $('#advanced-actors-search #hairColors').val(value);
                                $('#advanced-actors-search #hairColors').formSelect('destroy');
                                $('#advanced-actors-search #hairColors').formSelect();
                            } else {
                                $('#hairColors', self.$searchForm).val(value);
                                $('#hairColors', self.$searchForm).formSelect('destroy');
                                $('#hairColors', self.$searchForm).formSelect();
                            }
                        }
                    }
                    break;
                case 'eyeColors':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            if ($(window).width() > 500) {
                                $('#advanced-actors-search #eyeColors').val(value);
                                $('#advanced-actors-search #eyeColors').formSelect('destroy');
                                $('#advanced-actors-search #eyeColors').formSelect();
                            } else {
                                $('#eyeColors', self.$searchForm).val(value);
                                $('#eyeColors', self.$searchForm).formSelect('destroy');
                                $('#eyeColors', self.$searchForm).formSelect();
                            }
                        }
                    }
                    break;
                case 'skills':
                    // checkbox
                    $.each(value, function(i, skill) {
                        if ($(window).width() > 500) {
                            if ($('#advanced-actors-search input.skills[value="' + skill + '"]').length > 0) {
                                $('#advanced-actors-search input.skills[value="' + skill + '"]').prop('checked', true);
                            }
                        } else {
                            if ($('input.skills[value="' + skill + '"]', self.$searchForm).length > 0) {
                                $('input.skills[value="' + skill + '"]', self.$searchForm).prop('checked', true);
                            }
                        }
                    });
                    break;
                case 'driverLicences':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            if ($(window).width() > 500) {
                                $('#advanced-actors-search #driverLicences').val(value);
                                $('#advanced-actors-search #driverLicences').formSelect('destroy');
                                $('#advanced-actors-search #driverLicences').formSelect();
                            } else {
                                $('#driverLicences', self.$searchForm).val(value);
                                $('#driverLicences', self.$searchForm).formSelect('destroy');
                                $('#driverLicences', self.$searchForm).formSelect();
                            }
                        }
                    }
                    break;
                case 'languages':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            if ($(window).width() > 500) {
                                $('#advanced-actors-search #languages').val(value);
                                $('#advanced-actors-search #languages').formSelect('destroy');
                                $('#advanced-actors-search #languages').formSelect();
                            } else {
                                $('#languages', self.$searchForm).val(value);
                                $('#languages', self.$searchForm).formSelect('destroy');
                                $('#languages', self.$searchForm).formSelect();
                            }
                        }
                    }
                    break;
                case 'countries':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            if ($(window).width() > 500) {
                                $('#advanced-actors-search #countries').val(value);
                                $('#advanced-actors-search #countries').formSelect('destroy');
                                $('#advanced-actors-search #countries').formSelect();
                            } else {
                                $('#countries', self.$searchForm).val(value);
                                $('#countries', self.$searchForm).formSelect('destroy');
                                $('#countries', self.$searchForm).formSelect();
                            }
                        }
                    }
                    break;
                case 'cantons':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            if ($(window).width() > 500) {
                                $('#advanced-actors-search #cantons').val(value);
                                $('#advanced-actors-search #cantons').formSelect('destroy');
                                $('#advanced-actors-search #cantons').formSelect();
                            } else {
                                $('#cantons', self.$searchForm).val(value);
                                $('#cantons', self.$searchForm).formSelect('destroy');
                                $('#cantons', self.$searchForm).formSelect();
                            }
                        }
                    }
                    break;
                case 'status':
                    if (typeof(value) != "undefined" && value != null) {
                        if (value.constructor === Array) {
                            if ($(window).width() > 500) {
                                $('#advanced-actors-search #status').val(value);
                                $('#advanced-actors-search #status').formSelect('destroy');
                                $('#advanced-actors-search #status').formSelect();
                            } else {
                                $('#status', self.$searchForm).val(value);
                                $('#status', self.$searchForm).formSelect('destroy');
                                $('#status', self.$searchForm).formSelect();
                            }
                        }
                    }
                    break;
                case 'nationalities':
                    if (typeof(value) != "undefined" && value != null && value != '') {
                        if ($(window).width() > 500) {
                            $('#advanced-actors-search #nationalities').val(value);
                            $('#advanced-actors-search #nationalities').formSelect('destroy');
                            $('#advanced-actors-search #nationalities').formSelect();
                        } else {
                            $('#nationalities', self.$searchForm).val(value);
                            //$('#nationalities', self.$searchForm).formSelect('destroy');
                            //$('#nationalities', self.$searchForm).formSelect();
                        }
                    }
                    break;
                case 'tribute':
                    if (typeof(value) != "undefined" && value == 1) {
                        if ($(window).width() > 500) {
                            if ($('#advanced-actors-search #tribute').length > 0) {
                                $('#advanced-actors-search #tribute').prop('checked', true);
                            }
                        } else {
                            if ($('#advanced-actors-search #tribute_mobile').length > 0) {
                                $('#advanced-actors-search #tribute_mobile').prop('checked', true);
                            }
                        }
                    }
                    break;
                case 'silhouette':
                    if (typeof(value) != "undefined" && value == 1) {
                        if ($(window).width() > 500) {
                            if ($('#advanced-actors-search #silhouette').length > 0) {
                                $('#advanced-actors-search #silhouette').prop('checked', true);
                            }
                        } else {
                            if ($('#advanced-actors-search #silhouette_mobile').length > 0) {
                                $('#advanced-actors-search #silhouette_mobile').prop('checked', true);
                            }
                        }
                    }
                    break;
            }
        });

        if ($('#age', this.$searchForm).length > 0) {
            var $ageRange = $('#age', this.$searchForm)[0];
            if ($ageRange.noUiSlider === undefined) {
                this.uiInitAgeRange();
            }
            $ageRange.noUiSlider.set([minAge, maxAge]);
        } else {
            if ($('input#minAge').length > 0) {
                $('input#minAge').val(minAge);
            }
            if ($('input#maxAge').length > 0) {
                $('input#maxAge').val(maxAge);
            }
        }

        M.updateTextFields();

        // Temporary hide the item count
        $('.title-items-count').css('opacity', 0);

        // Trigger the search button to update the results
        if ($(window).width() > 500) {
            this.$searchForm.add('#advanced-actors-search').submit();
        } else {
            $('#search-box-mobile form').first().trigger('submit');
        }
    },

    launchSearchFromHomepage: function() {
        if ($('input[name="fromHomepage"]').length > 0 && $('input[name="fromHomepage"]').val() == 1) {
            this.searchFormForceCreateCookie = true;
            helper.deleteCookie(this.searchFormCookieName);

            // Trigger the search button to (update the results) and create the cookie
            if ($(window).width() > 500) {
                this.$searchForm.add('#advanced-actors-search').submit();
            } else {
                $('#search-box-mobile form').first().trigger('submit');
            }
        }
    },

    /**
     * We can use GET parameters to search actors, for example: /?video=1.
     * If we detect GET parameters in the URI, try to set the filter in the form.
     * Because if we don't do that, the infinite scroll will do not take into account our GET parameters.
     */
    searchByGetParameter: function() {
        var video = helper.getUrlParameter('video');
        if (video != '') {
            $('#video-filter').addClass('active');
        }
    },

    reinitializeSearch: function () {
        var self = this;

        $('body').on('click', '.btn-reinit', function(e) {
            e.preventDefault();

            $(this).attr('data-activated', true);

            // Clear the search criteria (for the top form)

            $('#nameActor', self.$searchForm).val('');

            $('#sexe', self.$searchForm).val('');
            $('#sexe', self.$searchForm).formSelect('destroy');
            $('#sexe', self.$searchForm).formSelect();

            if ($('#age', self.$searchForm).length > 0) {
                var $ageRange = $('#age', self.$searchForm)[0];
                $ageRange.noUiSlider.set([18, 100]);
            } else {
                if ($('input#minAge').length > 0) {
                    $('input#minAge').val('');
                }
                if ($('input#maxAge').length > 0) {
                    $('input#maxAge').val('');
                }
            }

            // Clear the search criteria (for the advanced search form)

            if ($(window).width() > 500) {
                $('#advanced-actors-search select').val('');
                $('#advanced-actors-search select').formSelect('destroy');
                $('#advanced-actors-search select').formSelect();

                $('#advanced-actors-search :checkbox').prop('checked', false);
            } else {
                $('select', self.$searchForm).prop('selectedIndex', 0);
                $('select', self.$searchForm).formSelect();

                $(':checkbox', self.$searchForm).prop('checked', false);

                $('#tribute_mobile').prop('checked', false);
                $('#silhouette_mobile').prop('checked', false);
            }

            M.updateTextFields();

            // Clear the cookies
            helper.setCookie(self.searchFormCookieName, '', 1);
            helper.deleteCookie(self.searchFormCookieName);

            // Trigger the search button to update the results
            if ($(window).width() > 500) {
                self.$searchForm.add('#advanced-actors-search').submit();
            } else {
                $('#search-box-mobile form').first().trigger('submit');
            }
        });
    },
};

module.exports = new FrontActorsArchive();
